import { Card, CardContent } from '@/components/ui/card';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function KalenderCardEmpty() {
  const { t } = useTranslation();

  return (
    <Card className="bg-white border-neutrals-300 shadow-xs p-4">
      <CardContent className="flex flex-col items-center justify-center gap-2 p-6 text-center">
        <FontAwesomeIcon
          icon={faCalendarStar}
          className="text-neutrals-700 text-2xl w-8 h-8"
        />
        <span className="font-medium text-neutrals-900">
          {t('domain.termine.kalender.table.empty')}
        </span>
        <span className="text-sm text-neutrals-700">
          {t('domain.termine.kalender.table.info')}
        </span>
      </CardContent>
    </Card>
  );
}
